/**
 * Card — the raised surface every app sets content on (ADR-0088 D2): the
 * card fill, the grouped-panel radius (10 px), a soft border and the card
 * shadow.
 *
 * `hero` is the page's single highest-level card (Home's Today card, a
 * program screen's card): the hero radius (12 px), so no page picks it.
 * `compact` is Manager's dense dashboard card: the card radius (8 px) and the
 * light shadow, where a grid of large raised cards would read as heavy.
 * `render` sets the element: a `<section>` or `<article>` with its own label,
 * as landmarks need. Padding and layout stay with the page.
 */
import { useRender } from '@base-ui/react/use-render';
import { cva } from 'class-variance-authority';
import { cn } from './cn.js';
/** The card's classes, for a part that renders its own element (a dialog
 * popup with the card look). */
export const cardVariants = cva('border border-border-default/70 bg-surface-card', {
    variants: {
        compact: {
            true: 'rounded-token-card shadow-soft',
            false: 'rounded-token-card-lg shadow-card',
        },
        hero: { true: '', false: '' },
    },
    compoundVariants: [{ compact: false, hero: true, class: 'rounded-token-card-xl' }],
    defaultVariants: { compact: false, hero: false },
});
export function Card({ compact = false, hero = false, render, className, ref, ...props }) {
    return useRender({
        render,
        ref,
        defaultTagName: 'div',
        props: { ...props, 'data-slot': 'card', className: cn(cardVariants({ compact, hero }), className) },
    });
}
//# sourceMappingURL=card.js.map